// The 4 implemented compliance cells (derived from meta/compliance/global.yaml).
// Stub cells (02, 04, 05, 07, 08, 09, 10, 11) archived to _deleteme/code/apps-web/.
//
// This stays a hand-maintained mirror for Phase 5 — codegen from the
// metagraph YAML lands in a later phase. If a cell is added to the
// metagraph, add the component to cells/index.ts and mirror it here.
// The names + roles are referenced by the cell tab strip + cell-component
// dispatch in §5.4.

export type CellSpec = {
  name: string;
  title: string;
  purpose: string;
  roles: ReadonlyArray<'compliance'>;
};

export const CELLS: ReadonlyArray<CellSpec> = [
  {
    name: 'dashboard',
    title: 'Dashboard',
    purpose: "Overview: queue depths, in-flight reviews, today's filings.",
    roles: ['compliance'],
  },
  {
    name: 'pending-reviews',
    title: 'Reviews',
    purpose: 'Active review queue: KYC, accreditation, sanctions hits, fiduciary decisions.',
    roles: ['compliance'],
  },
  {
    name: 'filings-calendar',
    title: 'Filings',
    purpose: 'Upcoming + recent regulatory filings.',
    roles: ['compliance'],
  },
  {
    name: 'incidents',
    title: 'Incidents',
    purpose: 'Active compliance incidents + remediation tracking.',
    roles: ['compliance'],
  },
];

export const defaultCellName = 'dashboard';

export function findCell(name: string): CellSpec | undefined {
  return CELLS.find((c) => c.name === name);
}
